import colors from 'tailwindcss/colors'
import { MessageSenderType } from '../../../shared-src/message'

export function hexForTwColor(twColor: string): string {
	const [name, shadeId] = twColor.split('-')
	const color = colors[name as keyof typeof colors]
	if (typeof color === 'string')
		return color
	const shadeHex = color[shadeId as keyof typeof color]
	return shadeHex
}

export interface ColorSet { 
	background: string
	twBackground: string
	border: string
	twBorder: string
	text: string
	twText: string
	dark: string
	twDark: string
}

// TODO rename params, it's used not only for sender
export function getColorSet(params: { senderType?: MessageSenderType, senderColor?: string }): ColorSet {
	let senderType = params.senderType ?? 'user'
	let baseTwColor = 'gray'
	switch (senderType) {
		case 'user':
		case 'admin':
			baseTwColor = params.senderColor ?? 'gray'
			break
		case 'bot': baseTwColor = 'lime'; break
		case 'system': baseTwColor = 'rose'; break
		case 'error': baseTwColor = 'red'; break
	}

	let twBackground = `${baseTwColor}-100`
	let twBorder = `${baseTwColor}-300`
	let twText = 'gray-900'
	let twDark = `${baseTwColor}-700`

	if (senderType !== 'user' && senderType !== 'admin')
		twBackground = 'white'
	if (senderType === 'error') {
		twText = 'red-500'	
		twDark = 'red-500'
	}

	return { 
		background: hexForTwColor(twBackground),
		twBackground,
		border: hexForTwColor(twBorder),
		twBorder,
		dark: hexForTwColor(twDark),
		twDark,
		text: hexForTwColor(twText),
		twText
	}
}

